import { useQuery } from '@tanstack/react-query';

import { getMerchantAdCampaign } from 'apis/ad-bookings/api';
import { CampaignType } from 'apis/restaurant-api/merchant-admin/campaigns/types';

import { CampaignsQueryKeys } from '../../campaignsQueryKeys';
import { CampaignStatus, MerchantAdCampaign } from '../../types';

export const useMerchantAdCampaign = ({
  merchantId,
  campaignId,
  enabled,
}: {
  merchantId: string;
  campaignId: string;
  enabled: boolean;
}) => {
  const { data: adCampaign, isLoading } = useQuery(
    CampaignsQueryKeys.ADS.MERCHANT.GET_CAMPAIGN(merchantId, campaignId),
    () =>
      getMerchantAdCampaign().then(
        (campaign): MerchantAdCampaign => ({
          ...campaign,
          campaign_type: CampaignType.ADS,
          status: campaign.status.toLowerCase() as CampaignStatus,
        }),
      ),
    {
      refetchOnWindowFocus: false,
      enabled: enabled && !!merchantId && !!campaignId,
      retry: false,
    },
  );

  return { adCampaign, isLoading };
};
